// extracted by mini-css-extract-plugin
module.exports = {"topNavigation":"_1VpLF","container":"_130wn","categoriesContainer":"y6M3q","link":"Rjt5J"};